import React from 'react';
import AiAgreementIndicator from './AiAgreementIndicator';

/**
 * Commandment IV: what produced an AI draft, and its confidence only if the backend measured one.
 * Never invents a figure. A missing confidence reads "not provided by the model"; a failed measurement
 * shows the backend's reason. `provenance` is the stored aiProvenance block (absent on older drafts).
 */
export const CONFIDENCE_NOT_PROVIDED_TEXT = 'Confidence: not provided by the model.';

const noteStyle = { fontSize: 12, color: 'var(--color-text-muted)', margin: 0 };

export default function AiProvenanceNote({ provenance, confidence, unavailableReason, testId = 'ai-provenance-note' }) {
    const p = provenance && typeof provenance === 'object' ? provenance : null;
    const conf = typeof p?.confidence === 'number' ? p.confidence : typeof confidence === 'number' ? confidence : null;
    const reason = p?.confidenceUnavailableReason || unavailableReason || null;
    return (
        <div data-testid={testId} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {p ? (
                <p style={noteStyle} data-testid="ai-provenance-source">
                    Drafted by AI model {p.modelId || 'unknown'} (prompt {p.promptId || 'unknown'}
                    {p.requestId ? `, request ${p.requestId}` : ''}). A human must review before it is relied on.
                </p>
            ) : (
                <p style={noteStyle} data-testid="ai-provenance-source">
                    Model details were not recorded for this draft (generated before provenance tracking).
                </p>
            )}
            {conf !== null || reason ? (
                <AiAgreementIndicator
                    confidence={conf}
                    runs={p?.confidenceRuns ?? undefined}
                    validSamples={p?.validSamples ?? undefined}
                    reasoningRefs={p?.reasoningRefs}
                    unavailableReason={reason || undefined}
                />
            ) : (
                <p style={noteStyle} data-testid="ai-confidence-not-provided">{CONFIDENCE_NOT_PROVIDED_TEXT}</p>
            )}
        </div>
    );
}
